import { Link } from "react-router-dom"

type Props = {
  id: string
  title: string
}

export default function ToolCard({ id, title }: Props) {
  return (
    <Link to={`/${id}`}>
      <div className="p-8 border border-slate-500 rounded-lg hover:bg-gray-50 cursor-pointer">
        <h3 className="text-lg font-semibold">{title}</h3>
      </div>
    </Link>
  )
}